import { useSelector } from "react-redux";
import { UITravelInsuranceAgeLimit } from "@flights/types";
import { getCartPassengerMaxAge, getCartPassengerMinAge } from "../../../store/cartDetails/selectors";
import { grumble } from "../../../utils/flog";

export default function useShouldShowTravelInsurance(
  isInsurancePresent: boolean,
  ageLimit?: UITravelInsuranceAgeLimit
) {
  const cartPassengersMaxAge = useSelector(getCartPassengerMaxAge);
  const cartPassengersMinAge = useSelector(getCartPassengerMinAge);

  if (isInsurancePresent && ageLimit) {
    if (cartPassengersMaxAge === -1 || cartPassengersMinAge === -1) {
      grumble(
        `cart passengers DOB restriction is corrupted for the Canada insurance maxAge: ${cartPassengersMaxAge}, minAge: ${cartPassengersMinAge}`
      );
      return false;
    } else {
      const { maxAge, minAge } = ageLimit;
      if (cartPassengersMaxAge > maxAge || cartPassengersMinAge < minAge) {
        return false;
      }
    }
  }
  return isInsurancePresent;
}
